import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton, Popover, Input, Button } from 'element-ui';
import SelectListAnswer from '@/components/shared/answer-types/select-list/select-list.vue';
import 'element-ui/lib/theme-chalk/index.css';

export default {
	name: 'RaceCalendarFilterLayout',
	props: {
		filter: Object,
		championshipType: Array,
		competitionSerieType: Array,
		distances: Array,
		genders: Array,
		openWaterType: Array,
		raceAgeGroup: Array,
		swimType: Array,
		typesBySport: Array,
		counties: Array,
	},
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[CheckboxButton.name]: CheckboxButton,
		[CheckboxGroup.name]: CheckboxGroup,
		[Popover.name]: Popover,
		[Input.name]: Input,
		[Button.name]: Button,
        'select-list-answer': SelectListAnswer,
	},
	data() {
		return {
			typeBySportItem: [],
			perPage: 5,
			perPageOptions: [5, 10, 25, 50, 100],
			championshipTypeItem: [],
			competitionSerieTypeItem: [],
			distanceItem: [],
			gendersItem: [],
			openWaterTypeItem: [],
			raceAgeGroupItem: [],
			swimTypeItem: [],
			countiesItem: [],
			gendersItem: [],
			searchQuery: null,
			eventDateRange: '',
			inclusiveItem: [],
			womenOnlyWaveItem: [],
			inclusive: [{ label: 'Yes', id: 0 }],
			womenOnlyWave: [{ label: 'Yes', id: 0 }],
			isVisibleAddFilter: false,
			showFilterLabel: null
		}
	},
	watch: {
		filter: {
			handler(newVal, oldVal) {
				if (this.countiesItem != newVal.counties) {
					this.countiesItem = newVal.counties;
                }
			},
			deep: true
		},
		typeBySportItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.typesBySport = this.typeBySportItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		raceAgeGroupItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.raceAgeGroup = this.raceAgeGroupItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		distanceItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.distances = this.distanceItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		championshipTypeItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.championshipType = this.championshipTypeItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		competitionSerieTypeItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.competitionSerieType = this.competitionSerieTypeItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		swimTypeItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				if (oldVal.includes(1) && !newVal.includes(1)) {//1: means user uncheck swimtype then need null openwatertype
					this.openWaterTypeItem = [];
					filter.openWaterType = [];
				}
				filter.swimType = this.swimTypeItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		countiesItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.counties = this.countiesItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		openWaterTypeItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.openWaterType = this.openWaterTypeItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		gendersItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.genders = this.gendersItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		womenOnlyWaveItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.womenOnlyWave = this.womenOnlyWaveItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		},
		inclusiveItem: {
			handler(newVal, oldVal) {
				let filter = { ...this.filter };
				filter.inclusive = this.inclusiveItem;
				filter.options.page = 1;
				this.$emit("update:filter", filter);
			},
			deep: true
		}
	},
	computed: {
		defaultDateRange() {
			if (this.eventDateRange && this.eventDateRange.length) {
				return this.eventDateRange;
			}
			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();

			return new Date(yyyy, mm, dd);
		}
	},
	methods: {
		showAdditionalFilters() {
			this.isVisibleAddFilter = !this.isVisibleAddFilter;
			if (!this.isVisibleAddFilter) {
				this.showFilterLabel = 'More Filters';
			}
			else {
				this.showFilterLabel = 'Less Filters';
			}
		},
		searchForRaces() {
			let filter = { ...this.filter };
			filter.searchQuery = this.searchQuery;
			filter.options.page = 1;
			this.$emit("update:filter", filter);
		},
		isInArray(array, value) {
			if (!array) {
				return false;
			}
			return array.includes(value);
		},
		clearFilters() {
			var self = this;
			self.typeBySportItem = [];
			self.searchQuery = null;
			self.championshipTypeItem = [];
			self.competitionSerieTypeItem = [];
			self.distanceItem = [];
			self.gendersItem = [];
			self.openWaterTypeItem = [];
			self.raceAgeGroupItem = [];
			self.swimTypeItem = [];
			self.countiesItem = [];
			self.gendersItem = [];
			self.eventDateRange = '';
			let filter = { ...this.filter };
			filter.typesBySport = [];
			filter.searchQuery = null;
			filter.championshipType = [];
			filter.competitionSerieType = [];
			filter.distances = [];
			filter.genders = [];
			filter.openWaterType = [];
			filter.raceAgeGroup = [];
			filter.swimType = [];
			filter.counties = [];
			filter.inclusive = []; 
			filter.eventDateRange = '';
			filter.options.page = 1;
			filter.options.perPage = 10;
			this.$emit("update:filter", filter);
		},
		searchDateForRaces() {
			let filter = { ...this.filter };
			filter.eventDateRange = this.eventDateRange;
			filter.options.page = 1;
			this.$emit("update:filter", filter);
		},
	},
	mounted() {
		this.showFilterLabel = 'More Filters';
	}
};



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-calendar/filter-bar/filter-bar.js